import styled from 'styled-components';
import {
  color, container, fontFamily,
  fontSize,
  fontWeight,
  radius,
  screen,
  spacing
} from '../../../theme';

export const StyledWhenSchedule = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: ${spacing('xl4')};
`;

export const StyledWhenScheduleSwitcher = styled.div`
  background-color: ${color('white')};
  

  @media (max-width: ${screen('mdMax')}) {
    //width: 100%;
    min-width: ${container('xs2')};
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: ${spacing('md')} ${spacing('xl')} calc(${spacing('xs')} + ${spacing('lg')}) ${spacing('xl')};
    clip-path: polygon(
      0 0,
      100% 0,
      100% calc(100% - ${spacing('lg')}),
      50% 100%,
      0 calc(100% - ${spacing('lg')})
    );
    margin-bottom: 0;
    gap: ${spacing('md')};
    
  }

  @media (min-width: ${screen('md')}) {
    display: flex;
    align-items: center;
    border-radius: ${radius('full')};
    gap: ${spacing('lg')};
    padding: ${spacing('md')} ${spacing('lg')};
    margin-bottom: ${spacing('md')};
  }
`;

export const StyledWhenScheduleContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const StyledWhenScheduleTitle = styled.h3`
  color: ${color('text_subtle')};
  font-weight: ${fontWeight('black')};
  text-transform: uppercase;
  font-size: ${fontSize('md')};
  line-height: 1.25;
  margin-top: 0;
  margin-bottom: ${spacing('xs')};
`;

export const StyledWhenScheduleHours = styled.span`
  display: block;
  margin-bottom: ${spacing('lg')};
  font-family: ${fontFamily('display')};
  font-weight: ${fontWeight('light')};
  font-size: ${fontSize('xl4')};
  line-height: 1;
  text-transform: uppercase;

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('xl6')};
  }

  span {
    color: ${color('text_placeholder')};
  }

  .separator {
    color: ${color('emerald_700')};

    @media (max-width: ${screen('mdMax')}) {
      display: block;
      height: 0;
      overflow: hidden;
    }
  }
`;

export const StyledWhenScheduleExtra = styled.div`
  display: block;
  margin-top: ${spacing('xl')};
  font-weight: ${fontWeight('medium')};
  font-size: ${fontSize('sm')};
  line-height: 1.15;
  text-align: center;
  max-width: ${container('xs')};
`;
